<template>
  <div class="tonal-comment">
    <ul class="tonal-comment__header">
      <li class="tonal-comment__title">
        {{chartTitle}}
      </li>
      <li class="tonal-comment__tools" v-if="!dataEmpty">
        <el-button type="text" class="tonal-comment__tools-button" :disabled="saveChart" @click="onSave">
          <i class="material-icons color_grey">save</i>
        </el-button>
        <el-button type="text" class="tonal-comment__tools-button" v-if="!isEdit" @click="editChart">
          <i class="material-icons color_grey">edit</i>
        </el-button>
        <el-button type="text" class="views__tools-button" v-if="isEdit" @click="closeChart()">
          <i class="material-icons color_grey">exit_to_app</i>
        </el-button>
      </li>
    </ul>

    <el-card shadow="hover" class="publications-by-source__card" v-loading="pending">
      <tonal-comment-header :chart-name="name"/>
      <template v-if="!dataEmpty">
        <tonal-comment-body
            :data="data"
            :chart-name="name"
            :save-chart="saveChart"
            :title="chartTitle"
            @onSavedChart="handleSaved"
            @onSaveChart="handleSave"
        />
      </template>

      <template v-else>
        {{$t('feed.analytics.tonalComment.noData')}}.
      </template>

    </el-card>
  </div>
</template>

<script>
// mixins
import { analytics } from "../../../../../../../mixins/analytics";

// components
import TonalCommentHeader from "./header/TonalCommentHeader";
import TonalCommentBody from "./body/TonalCommentBody";
import {TRUST_COMMENT_DAILY} from "../../../../../../../store/actions/analytics";

export default {
  name: 'TonalComment',
  data() {
    return {
      chartTitle: this.$t('feed.analytics.tonalComment.title'),
      name: "TonalComment",
      saveChart: false
    };
  },
  mixins: [
    analytics
  ],
  mounted() {
    this.$store.dispatch(TRUST_COMMENT_DAILY, {chart: this.name, thread: this.$route.params.threadId});
  },
  components: {
    TonalCommentHeader,
    TonalCommentBody,
  }
};
</script>

<style>
.tonal-comment {
  margin-bottom: 40px;
}
.tonal-comment__header {
  display: flex;
  justify-content: space-between;
  align-items: start;
  padding: 0;
  margin: 0;
  list-style: none;
}
.tonal-comment__title {
  margin-bottom: 20px;
  font-family: "Roboto", "Arial", sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 19px;

  color: #5E6D82;
}
.tonal-comment__tools .material-icons {
  font-size: 16px;
}
.tonal-comment__tools {
  margin-top: 4px;
  margin-right: 15px;
}
.tonal-comment__tools-button {
  padding: 0;
  color: #5e6d82;
}

.tonal-comment__tools-button:hover {
  color: #B3BCCC;
  font-size: 12px;
}
@media screen and (max-width: 480px) {
  .publications-by-source__card {
    overflow-x: auto;  }
  .tonal-comment__tools {
    display: none;
  }
}
</style>
